import '@luminalearning/components/css/index.css';
import './index.css';
import './App.css';
import React from 'react';
import ReactDOM from 'react-dom';
import {
    ApolloProvider,
    ApolloClient,
    NormalizedCacheObject,
} from '@apollo/client';
import App from 'src/App';
import { initClient } from 'src/graphql';

const run = async () => {
    const apolloClient: ApolloClient<NormalizedCacheObject> = initClient();

    ReactDOM.render(
        <React.StrictMode>
            <ApolloProvider client={apolloClient}>
                <App />
            </ApolloProvider>
        </React.StrictMode>,
        document.getElementById('root')
    );
};

run();
